import { MouseEvent } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import UserTableCell from './UserTableCell';
import SnapshotTableCells from './SnapshotTableCells';

interface Props {
  users: { id: number; snapshot_id: number }[];
  selectedUser: number;
  handleClick: (event: MouseEvent<unknown>, userId: number) => void;
}

const CurrentUsersTable = ({ users, selectedUser, handleClick }: Props) => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>User</TableCell>
            <TableCell>Snapshot</TableCell>
            <TableCell>Sweep Time</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users?.map((user: any) => (
            <TableRow
              hover
              key={user.id}
              onClick={(event) => handleClick(event, user.id)}
              selected={user.id === selectedUser}
            >
              <UserTableCell userId={user.id} />
              <SnapshotTableCells snapshotId={user.snapshot_id} />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CurrentUsersTable;
